















import { Component, Vue } from 'vue-property-decorator';
import _com from "./assets/js/common";
@Component
export default class App extends Vue {
  browser = _com.browser()
  savigns() {
    (window as any).AlipayJSBridge && (window as any).AlipayJSBridge.call('exitAllApp', null,)
  }
  toLiveList(){
    if (this.$route.name == 'login' && this.$route.path == '/login') {
      this.savigns()
    } else {
      location.href = 'https://h5'+ process.env.VUE_APP_URI_DOMAIN +'/hd/debutBroadcastList/index.html'
    }
  }
}
